import { createSelector } from '@reduxjs/toolkit';

import { NodeData } from 'src/containers/ProjectDiagram/types/model';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectNodeDataArraySelector } from 'src/selectors/projectNodeDataArray';

export const projectNodeDataSelector = <T extends NodeData>(
  projectId: string,
  key: go.Key,
  isType: (data: any) => data is T
) =>
  createSelector(
    projectNodeDataArraySelector(projectId),
    (nodeDataArray) =>
      nodeDataArray.find(
        (nodeData): nodeData is T => isType(nodeData) && nodeData.key === key
      ) || null
  );

export const projectResourceNodeDataArraySelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(projectNodeDataArraySelector(projectId), (nodeDataArray) =>
      nodeDataArray.filter(isResource)
    )
);
